import Vue from 'vue';

export default function() {
	Vue.$ofsCrud.addResource({
		name: 'layout',
		pluralName: 'layouts',
		transport: 'davinci',
		options: {
			namespaced: true
		}
	});
}
